
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Comment choisir une agence web en évitant les arnaques ?",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Découvrez comment sélectionner une agence de communication web fiable pour booster votre visibilité, tout en évitant les pièges et les arnaques courantes.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Choisir une agence de communication Web : comment ne pas se faire arnaquer ?",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Les solutions pour booster votre visibilité en ligne ne manquent pas. Mais comment bien choisir la vôtre et éviter de vous faire arnaquer ? Cet article vous explique tout !",
        },
        // {
        //   hid: "og:image",
        //   property: "og:image",
        //   content: require("~/assets/img/og/og-facebook-apropos.jpg"),
        // },
      ],
    };
  },
};
